<app-checkbox
    *ngIf="showCheckbox"
    [id]="idPrefix"
    [label]="'patient.modal.replace-kit.tab' | translate"
    [checked]="withTablet"
    (checkedChange)="onWithTabletChange($event)"
    [invalid]="invalid"
    [disabled]="disabled"
></app-checkbox>
<app-button-selector
    *ngIf="withTablet"
    class="mt-2 mb-2 ms-4"
    [options]="tabletTypeOptions"
    [ngModel]="tabletType"
    (ngModelChange)="onTabletTypeChange($event)"
    [idPrefix]="idPrefix + '-type'"
    [name]="idPrefix + '-type'"
    [disabled]="disabled"
></app-button-selector>
<app-checkbox
    *ngIf="withTablet"
    [id]="idPrefix + '-simCard'"
    [label]="'patient.modal.replace-kit.simCard' | translate"
    [checked]="withSimCard"
    (checkedChange)="onWithSimCardChange($event)"
    [invalid]="invalid"
    [disabled]="disabled"
    class="mt-2 ms-4"
></app-checkbox>
